import React, { useState } from 'react'
import styled from 'styled-components'
import PageTitle from '../../_Components/Common/PageTitle/PageTitle'

const Scene = props => {
  const { sceneList, approveYn, setApproveYn, updateSceneApprove } = props

  const [playingId, setPlayingId] = useState(null)

  const statusList = [
    { name: 'Reviewing', value: 'P' },
    { name: 'Approved', value: 'Y' },
    { name: 'Disapproved', value: 'N' },
    { name: 'All', value: 'all' },
    { name: 'All Private', value: 'private' },
  ]

  const isPrivateTab = approveYn === 'private'

  const getDate = d => {
    if (!d) return ''
    const date = new Date(d)
    const kstDate = new Date(
      date.toLocaleString('en-US', { timeZone: 'Asia/Seoul' })
    )

    const formatted =
      `${kstDate.getFullYear()}-` +
      `${String(kstDate.getMonth() + 1).padStart(2, '0')}-` +
      `${String(kstDate.getDate()).padStart(2, '0')} ` +
      `${String(kstDate.getHours()).padStart(2, '0')}:` +
      `${String(kstDate.getMinutes()).padStart(2, '0')}:` +
      `${String(kstDate.getSeconds()).padStart(2, '0')}`

    return formatted
  }

  return (
    <>
      <PageTitle
        mainTitle={'Scene Pending Approve'}
        v1Link={''}
        navNames={['Scene']}
      />
      <SpaceResponsive height={10} />
      <section className="content">
        <div className="row">
          <section className="col-lg-12 connectedSortable">
            <div className="box box-info" style={{ padding: '0 10px' }}>
              <div className="box-body">
                <div style={{ marginTop: 10 }}>
                  <ButtonWrapper style={{ width: 'auto' }}>
                    {statusList.map((s, i) => (
                      <button
                        key={i}
                        style={{
                          backgroundColor:
                            approveYn === s.value ? '#007bff' : '#6c757d',
                        }}
                        onClick={() => {
                          setApproveYn(s.value)
                          setPlayingId(null)
                        }}
                      >
                        {s.name}
                      </button>
                    ))}
                  </ButtonWrapper>
                  <SpaceResponsive height={10} />
                  {sceneList.length === 0 && (
                    <EmptyBox>해당 상태의 씬이 없습니다.</EmptyBox>
                  )}
                  <ImageWrapper>
                    {sceneList.map((p, i) => {
                      const isPlaying = playingId === p.seq
                      const displayVideoUrl = p.mosaic || p.videoUrl
                      const displayThumbnail = p.mosaicThumbnail || p.thumbnail
                      const hasMosaic = !!p.mosaic
                      return (
                        <ImageBox key={i}>
                          <MediaArea
                            onClick={() =>
                              setPlayingId(isPlaying ? null : p.seq)
                            }
                          >
                            {isPlaying && displayVideoUrl ? (
                              <video
                                id="video"
                                src={displayVideoUrl}
                                controls
                                autoPlay
                                playsInline
                              />
                            ) : (
                              <img id="thumbnail" src={displayThumbnail} alt="" />
                            )}
                            {!isPlaying && displayVideoUrl && (
                              <div id="play-overlay">
                                <div id="play-icon">▶</div>
                              </div>
                            )}
                            {hasMosaic && (
                              <div id="mosaic-tag">MOSAIC</div>
                            )}
                            {p.publicYn === 'N' && (
                              <div id="private-tag">PRIVATE</div>
                            )}
                          </MediaArea>
                          <InfoBox>
                            <div id="meta">
                              <div style={{ fontSize: '11px', color: '#888' }}>
                                seq: {p.seq}
                              </div>
                              {p.motionName && (
                                <div style={{ fontWeight: 600 }}>
                                  {p.motionName}
                                </div>
                              )}
                              {p.userName && (
                                <div>
                                  user: {p.userName} ({p.userId})
                                </div>
                              )}
                              {p.prompt && (
                                <PromptWrapper>
                                  <div id="prompt">{p.prompt}</div>
                                  <div id="tooltip">{p.prompt}</div>
                                </PromptWrapper>
                              )}
                              {p.regDate && <div>{getDate(p.regDate)}</div>}
                            </div>
                          </InfoBox>
                          {!isPrivateTab && p.approveYn !== 'P' && (
                            <img
                              id="status"
                              src={`https://img.stipop.io/image/admin/${
                                p.approveYn === 'Y' ? 'check' : 'cancel'
                              }-icon.png`}
                              alt=""
                            />
                          )}
                          <SpaceResponsive height={10} />
                          {!isPrivateTab && p.approveYn === 'P' && (
                            <div id="button-wrapper">
                              <button
                                style={{ background: '#28a745' }}
                                onClick={() => {
                                  if (window.confirm('승인하시겠습니까?')) {
                                    updateSceneApprove(p.seq, 'Y')
                                  }
                                }}
                              >
                                Approve
                              </button>
                              <button
                                style={{ background: '#dc3545' }}
                                onClick={() => {
                                  if (window.confirm('거절하시겠습니까?')) {
                                    updateSceneApprove(p.seq, 'N')
                                  }
                                }}
                              >
                                Reject
                              </button>
                            </div>
                          )}
                        </ImageBox>
                      )
                    })}
                  </ImageWrapper>
                  <SpaceResponsive height={20} />
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
    </>
  )
}

export default Scene

const SpaceResponsive = styled.div`
  height: ${props => props.height}px;
  flex-shrink: 0;
`

const EmptyBox = styled.div`
  width: 100%;
  text-align: center;
  padding: 40px 0;
  color: #888;
`

const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 10px;
`

const ImageBox = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  #status {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 40px;
    height: 40px;
    z-index: 2;
  }

  #button-wrapper {
    width: 100%;
    max-width: 240px;
    display: flex;
    column-gap: 8px;
    justify-content: center;

    button {
      width: 100%;
      border: none;
      outline: none;
      border-radius: 4px;
      color: #fff;
      padding: 6px 0;

      &:hover {
        opacity: 0.85;
      }
    }
  }
`

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 10px 0;

  button {
    height: 35px;
    padding: 0 10px;
    box-sizing: border-box;
    margin-left: 10px;
    color: #fff;
    border-radius: 5px;
    border: none;

    &:hover {
      opacity: 0.8;
    }
  }
`

const MediaArea = styled.div`
  width: 100%;
  max-width: 240px;
  aspect-ratio: 1 / 1;
  margin: 0 auto;
  border-radius: 16px;
  overflow: hidden;
  background-color: #000;
  position: relative;
  cursor: pointer;

  #thumbnail {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  #video {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
    background-color: #000;
  }

  #play-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.25);
    transition: background-color 0.2s;
  }

  &:hover #play-overlay {
    background-color: rgba(0, 0, 0, 0.45);
  }

  #play-icon {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.9);
    color: #000;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 22px;
    padding-left: 4px;
    box-sizing: border-box;
  }

  #mosaic-tag {
    position: absolute;
    top: 8px;
    left: 8px;
    z-index: 2;
    padding: 3px 8px;
    border-radius: 9999px;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.04em;
    color: #fff;
    background: linear-gradient(135deg, #f97316, #ec4899);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);
  }

  #private-tag {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 2;
    padding: 3px 8px;
    border-radius: 9999px;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.04em;
    color: #fff;
    background: linear-gradient(135deg, #6b7280, #1f2937);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);
  }
`

const InfoBox = styled.div`
  width: 100%;
  max-width: 240px;
  margin: 0 auto;
  padding: 8px 4px;
  box-sizing: border-box;

  #meta {
    display: flex;
    flex-direction: column;
    row-gap: 2px;
    font-size: 12px;
    color: #333;
    word-break: break-all;
  }

  #prompt {
    color: #555;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

const PromptWrapper = styled.div`
  position: relative;
  cursor: pointer;

  #tooltip {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    top: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
    width: max-content;
    max-width: 280px;
    padding: 8px 10px;
    background-color: rgba(0, 0, 0, 0.85);
    color: #fff;
    font-size: 12px;
    line-height: 1.4;
    border-radius: 6px;
    word-break: break-word;
    white-space: normal;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    transition: opacity 0.15s ease;
    pointer-events: none;
  }

  #tooltip::before {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 6px;
    border-style: solid;
    border-color: transparent transparent rgba(0, 0, 0, 0.85) transparent;
  }

  &:hover #tooltip {
    visibility: visible;
    opacity: 1;
  }
`
